module.exports = __webpack_public_path__ + "img/googlereviewsp3.98b2c8de.png";